import { DataResponse } from 'genesis-suite/types/visualTypes'

export default function noData(res: DataResponse) {
    if (res === undefined) return false
    if (res === null) return true

    return !res.some(s => s.data?.length)
}
